// #genai Centralised constants for the guest-access flow.

// ─── Flow phases ─────────────────────────────────────────────────────────────

export const ACCESS_PHASES = {
  IDLE: 'idle',
  VALIDATING: 'validating',
  LEGACY: 'legacy',
  REDIRECTING: 'redirecting',
  EMAIL_INPUT: 'emailInput',
  GUEST_CHOICE: 'guestChoice',
  SENDING_EMAIL: 'sendingEmail',
  VERIFY_EMAIL: 'verifyEmail',
  POLLING: 'polling',
  VERIFIED: 'verified',
  ACCESS_DENIED: 'accessDenied',
  READY: 'ready',
  ERROR: 'error',
  LOADING: 'loading',
};

// ─── Polling configuration ───────────────────────────────────────────────────

export const POLLING_CONFIG = {
  /** Wait 20 s after email is sent before the first poll. */
  INITIAL_DELAY_MS: 20000,
  /** Poll every 5 s after the first tick. */
  POLL_INTERVAL_MS: 5000,
  /** Stop polling after 10 minutes. */
  MAX_POLL_DURATION_MS: 10 * 60 * 1000,
};

// ─── API response / verification statuses ────────────────────────────────────

export const VERIFICATION_STATUS = {
  VERIFIED: 'VERIFIED',
  VERIFIED_LC: 'verified',
  PENDING: 'pending',
  EXPIRED: 'EXPIRED',
  EXPIRED_LC: 'expired',
  FAILED: 'FAILED',
  FAILED_LC: 'failed',
  SUCCESS: 'SUCCESS',
};

// ─── Resend-email UI statuses ────────────────────────────────────────────────

export const RESEND_STATUS = {
  SENT: 'sent',
  RESENDING: 'resending',
  ERROR: 'error',
};

// ─── Email-verify page statuses ──────────────────────────────────────────────

export const EMAIL_VERIFY_STATUS = {
  VERIFYING: 'verifying',
  SUCCESS: 'success',
  ERROR: 'error',
};

// ─── SignInFlow step constants ───────────────────────────────────────────────

export const SIGN_IN_STEP = {
  loading: ACCESS_PHASES.LOADING,
  notShared: 'notShared',
  email: 'email',
  guestChoice: ACCESS_PHASES.GUEST_CHOICE,
  verifyEmail: ACCESS_PHASES.VERIFY_EMAIL,
  accessDenied: ACCESS_PHASES.ACCESS_DENIED, // checkResourceAccess returned hasAccess:false
};

// ─── Routes & redirects ─────────────────────────────────────────────────────

export const GUEST_ROUTES = {
  SIGNIN: '/signin',
  SIGNIN_REDIRECT_PREFIX: '/signin?redirect=',
  DEFAULT_REDIRECT: '/',
};

// ─── Error / UI messages ─────────────────────────────────────────────────────

export const GUEST_ERROR_MESSAGES = {
  INVALID_EMAIL: 'Please enter a valid email address.',
  GENERIC_ERROR: 'Something went wrong. Please try again.',
  SEND_FAILED: 'Unable to send email. Please try again.',
  RESEND_FAILED: 'Unable to resend. Please try again.',
  TIMEOUT: 'Verification timed out. Please try again.',
  VERIFICATION_FAILED: 'Verification failed. Please try again.',
  GUEST_PROFILE_FETCH_FAILED: 'Failed to fetch guest user profile',
};

export const LINK_EXPIRY_MINUTES = 10;
